import { render, staticRenderFns } from "./index.vue?vue&type=template&id=eaae9d3e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./index.vue?vue&type=style&index=1&lang=css&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./index.vue?vue&type=style&index=0&lang=scss&module=true&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./index.vue?vue&type=style&index=0&lang=scss&module=true&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/vue-hot-reload-api/dist/index.js").rerender("eaae9d3e")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eaae9d3e')) {
      api.createRecord('eaae9d3e', component.options)
    } else {
      api.reload('eaae9d3e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=eaae9d3e&", function () {
      api.rerender('eaae9d3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notifications/show/index.vue"
export default component.exports